import { render } from "./WaitingRoomsList.vue?vue&type=template&id=c67062b0"
import script from "./WaitingRoomsList.vue?vue&type=script&lang=js"
export * from "./WaitingRoomsList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__